module.exports = __webpack_public_path__ + "img/_g.7fd162b3.svg";